module.exports = __webpack_public_path__ + "img/boho-style-7314646_1280_thumb.8b5a55a5.png";